/*global ymaps*/

export default function ContactsMap(container) {
    const mapBlock = container;
    const mapScriptUrl = mapBlock.getAttribute("data-map-src");

    loadScript(mapScriptUrl, initContactsMap);

    function initContactsMap() {

        function contactsMap() {
            const mapContainer = mapBlock;
            const latitude = mapContainer.getAttribute("data-map-latitude");
            const longitude = mapContainer.getAttribute("data-map-longitude");

            const mapCenter = [latitude, longitude];

            const map = new ymaps.Map("contacts-map", {
                center: mapCenter,
                zoom: 17,
                controls: []
            });

            const markerImage = mapContainer.getAttribute("data-map-marker");

            const marker = new ymaps.Placemark(map.getCenter(), {}, {
                iconLayout: "default#image",
                iconImageSize: [100, 110],
                iconImageOffset: [-50, -110],
                iconImageHref: markerImage
            }, {
                cursor: "default"
            });

            map.geoObjects.add(marker);
        }

        ymaps.ready(contactsMap);
    }

    // load script async from file or url
    function loadScript(src, callback) {
        // Adding the script tag to the head as suggested before
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.src = src;
        script.async = true;

        // Then bind the event to the callback function.
        // There are several events for cross browser compatibility.
        if ( callback ) {
            script.onreadystatechange = callback;
            script.onload = callback;
        }

        // Fire the loading
        const head = document.getElementsByTagName("head")[0];
        head.appendChild(script);
    }
}